import CustomInput from '@app/components/CustomInput'
import { ITenantRent, TenantRent } from '@app/models/TenantRent'
import { IGlobalConfigurationState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { List } from 'immutable'
import * as React from 'react'
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap'

interface IComponentProps {
  className?: string
  name?: string
  onChange: (newRentDetails: List<ITenantRent>) => void
  required?: boolean
  style?: React.CSSProperties
  value: List<ITenantRent>
}

type ComponentProps = IComponentProps & IGlobalConfigurationState

export default class RentDetailsEditor extends React.PureComponent<
  ComponentProps
> {
  constructor(props: ComponentProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    return (
      <div className={this.props.className} style={this.props.style}>
        <div className='mb-2'>
          <Button color='primary' outline onClick={this._addItem} size='sm'>
            {'Add Tenant'}
          </Button>
        </div>
        {this.props.value.toArray().map((val, i) => {
          return (
            <InputGroup key={`item-${i}`} className='mb-2'>
              <Input
                type='text'
                placeholder='Tenant Description'
                bsSize='sm'
                name={
                  this.props.name
                    ? `${this.props.name}${i + 1}Description`
                    : undefined
                }
                onChange={(e) => this._changeDescription(i, e.target.value)}
                value={val.description}
              />

              <CustomInput
                className='ml-2'
                type='number'
                bsSize='sm'
                name={
                  this.props.name
                    ? `${this.props.name}${i + 1}Amount`
                    : undefined
                }
                onChange={(e) => this._changeAmount(i, e)}
                value={val.rentAmount}
              />

              <InputGroupAddon addonType='append'>
                <Button
                  color='danger'
                  onClick={() => this._deleteItem(i)}
                  outline
                  title='Delete'
                >
                  <FontAwesomeIcon icon={['fal', 'trash']} fixedWidth />
                </Button>
              </InputGroupAddon>
            </InputGroup>
          )
        })}
      </div>
    )
  }

  private _addItem() {
    const tenant = new TenantRent({
      description: '',
      rentAmount: 0,
    })
    this.props.onChange(this.props.value.push(tenant))
  }

  private _changeAmount(index: number, newValue: number) {
    this.props.onChange(
      this.props.value.setIn([index, 'rentAmount'], newValue),
    )
  }

  private _changeDescription(index: number, newValue: string) {
    this.props.onChange(
      this.props.value.setIn([index, 'description'], newValue),
    )
  }

  private _deleteItem(index: number) {
    this.props.onChange(this.props.value.delete(index))
  }
}
